import { render, staticRenderFns } from "./notaVenta.vue?vue&type=template&id=2c726b95&scoped=true&"
import script from "./notaVenta.vue?vue&type=script&lang=js&"
export * from "./notaVenta.vue?vue&type=script&lang=js&"
import style0 from "./notaVenta.vue?vue&type=style&index=0&id=2c726b95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c726b95",
  null
  
)

export default component.exports